<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
import { userManager } from "@/auth.service";
import { loadLocale } from "@/i18n";
import { localize } from "vee-validate";
export default {
  name: "OpenIDCallback",
  methods: {
    ...mapActions(["setUser"])
  },
  mounted() {
    userManager
      .signinRedirectCallback()
      .then(usr => {
        this.$store.dispatch("setUser", usr);        
        this.$i18n.locale = usr.profile.locale;
        localStorage.setItem("locale", usr.profile.locale);
        loadLocale(usr.profile.locale, function(messages) {
          localStorage.setItem("localeMessages", JSON.stringify(messages));  
          document.title = messages.topbar.account;
          localize(messages.validations.code, messages.validations);     
        }); 
        let url = localStorage.getItem("path");
        if (url) {
          this.$router.push(url);
        } else {
          this.$router.push({ name: "profile" });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>
